import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';

import { ArrowDropDown } from '@material-ui/icons';
import UiKitButton from 'components/UiKit/Button';
import PopupMenu from 'components/UiKit/PopupMenu';
import DeleteIcon from 'components/Icons/components/DeleteIcon';
import { useFormikContext } from 'formik';
import { paths } from 'routes/paths';

const cropZoneActionsDefaultPropSetIsMenuOpen = () => {};
const CropZoneActions = ({
  children,
  onSave,
  disabled = false,
  canDelete = false,
  isMenuOpen = false,
  setIsMenuOpen = cropZoneActionsDefaultPropSetIsMenuOpen
}) => {
  const history = useHistory();
  const { action } = useParams();
  const { isSubmitting } = useFormikContext();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const isEditing = action === 'edit';

  const saveStyles = !isEditing
    ? {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        borderRight: 'none'
      }
    : {};

  return (
    <>
      {isEditing && (
        <div className="absolute left-0">
          <UiKitButton
            danger
            variant="text"
            icon={<DeleteIcon />}
            onClick={() => setDeleteModalOpen(true)}
            disabled={!canDelete}
          >
            Delete
          </UiKitButton>
        </div>
      )}
      <div className="flex space-x-3">
        <UiKitButton
          variant="text"
          onClick={() => history.push(paths.properties)}
        >
          Cancel
        </UiKitButton>
        <div className="flex top-0 white-bg">
          <UiKitButton
            variant="primary"
            disabled={disabled || isSubmitting}
            loading={isSubmitting}
            style={saveStyles}
            onClick={onSave}
          >
            Save
          </UiKitButton>
          {!isEditing ? (
            <PopupMenu
              open={isMenuOpen}
              onOpenChange={setIsMenuOpen}
              placement="topRight"
              trigger={
                <UiKitButton
                  variant="primary"
                  aria-label="More save options"
                  disabled={disabled || isSubmitting}
                  style={{
                    borderTopLeftRadius: '0',
                    borderBottomLeftRadius: '0',
                    borderLeft: 'none'
                  }}
                >
                  <ArrowDropDown />
                </UiKitButton>
              }
            >
              <div
                className="flex flex-col font-normal text-gray-700"
                style={{ minWidth: '300px' }}
              >
                {children}
              </div>
            </PopupMenu>
          ) : (
            children({ deleteModalOpen, setDeleteModalOpen })
          )}
        </div>
      </div>
    </>
  );
};

CropZoneActions.propTypes = {
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  canDelete: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
  setIsMenuOpen: PropTypes.func
};

export default CropZoneActions;
